import React from 'react';

import { Button, Modal, Message, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import css from '../../chart-list.module.css';

export default function DeleteModal({ category, chartId, organization, sync, onClose }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [isDeleting, setIsDeleting] = React.useState(false);

    const cannotDelete = React.useMemo(() => {
        if (!category) {
            return true;
        }
        return category.is_linked_to_bookings;
    }, [category]);

    const categoryToDelete = React.useMemo(() => {
        return {
            type: cannotDelete ? 'danger' : 'warning',
            message: t(`ticket.charts.category.deleteModal.${cannotDelete ? 'denied' : 'warning'}`)
        };
    }, [category, cannotDelete]);

    const onSubmit = React.useCallback(() => {
        setIsDeleting(true);
        category
            .delete({
                organizationId: organization.id,
                chartId: chartId
            })
            .then(() => {
                toast.success(t('ticket.charts.chart.delete-modal.toast-success'));
                sync({ allow_cache: false, cache: false });
            })
            .catch(e => {
                console.error(e);
                toast.error(t('ticket.charts.chart.delete-modal.toast-error'));
            })
            .finally(() => {
                onClose();
                setIsDeleting(false);
            });
    }, [category, chartId, organization, toast, onClose, sync]);

    return (
        <Modal
            allowExternalClosing={false}
            open={Boolean(category)}
            onClose={onClose}
            submitButton={<Button primary label={t('ticket.common.action.delete')} onClick={onSubmit} isLoading={isDeleting} disabled={cannotDelete} />}
            cancelButton={<Button onClick={onClose} label={t('ticket.common.action.cancel')} disabled={isDeleting} />}
            title={t('ticket.charts.category.deleteModal.title')}
        >
            <div className={css['categories-modal-message']}>
                <Message type={categoryToDelete.type}>{categoryToDelete.message}</Message>
                {!cannotDelete && t('ticket.charts.category.deleteModal.description')}
            </div>
        </Modal>
    );
}
